import { Header } from "~/types/table";

export const SECURITY_PIPELINE_GITHUB_WORKFLOWS_TABLE_HEADERS: Header[] = [
  {
    id: "TITLE",
    label: "Fixes",
    sortable: true,
  },
  {
    id: "AUTHOR",
    label: "Author",
    sortable: false,
  },
  {
    id: "UPDATED_AT",
    label: "Last Updated",
    sortable: true,
  },
  {
    id: "STATUS",
    label: "Status",
    sortable: false,
  },
];
